import { themeColors } from "theme";

export const eligibilityColor = {
  ELIGIBLE: "green",
  INELIGIBLE: "red",
};

export const agingColor = {
  EXPIRED: "orange",
  WITHIN_WINDOW: "blue",
};

export const eligibilitySignalColor = {
  ELIGIBLE: themeColors.successColor,
  INELIGIBLE: themeColors.errorColor,
};

export const agingSignalColor = {
  EXPIRED: themeColors.warningColor,
  WITHIN_WINDOW: themeColors.blueColor,
};

const ELIGIBILITY_LABELS = {
  ELIGIBLE: "Elegível para Breakage",
  INELIGIBLE: "Não elegível",
};

const AGING_LABELS = {
  EXPIRED: "Vencido",
  WITHIN_WINDOW: "A vencer",
};

const ORIGIN_TYPE_LABELS = {
  SOLICITATION: "Solicitação de carga",
  TRANSFER: "Transferência",
  STANDARD: "Crédito padrão",
  FUNDS_IN: "Entrada via PIX",
  FOUND_IN: "Entrada via PIX",
  UNKNOWN: "Origem não classificada",
};

const INELIGIBILITY_REASON_LABELS = {
  FUNDS_IN_EXEMPT: "Entrada via PIX — não participa do resgate",
  FOUND_IN_EXEMPT: "Entrada via PIX — não participa do resgate",
};

const OWNER_RESOLUTION_LABELS = {
  RESOLVED: "Empresa responsável confirmada",
  PENDING: "Empresa responsável em análise",
};

const CONSUMPTION_LABELS = {
  NONE: "Não utilizado pelo participante",
  PARTIAL: "Utilizado em parte",
  FULL: "Totalmente utilizado",
};

export const labelEligibility = (code) =>
  ELIGIBILITY_LABELS[code] || code || "—";

export const labelAging = (code) => AGING_LABELS[code] || code || "—";

export const labelOriginType = (code) =>
  ORIGIN_TYPE_LABELS[code] || code || "—";

export const labelIneligibilityReason = (code) =>
  INELIGIBILITY_REASON_LABELS[code] || code || "—";

export const labelOwnerResolution = (code) =>
  OWNER_RESOLUTION_LABELS[code] || code || "—";

export const labelConsumption = (code) =>
  CONSUMPTION_LABELS[code] || code || "—";

export const formatSaldoCount = (count) => {
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? "saldo" : "saldos"}`;
};

export const BREAKAGE_KPI_HELP = {
  available:
    "Valor canônico do summary: saldo comprovadamente disponível para solicitar Redemption (quando a fórmula financeira estiver aprovada). Não é a soma dos lotes da listagem. HTTP 202 de solicitação não zera este card.",
  eligible:
    "Prévia dos lotes com elegibilidade Breakage (ELIGIBLE). Isso NÃO equivale automaticamente a AVAILABLE_FOR_REDEMPTION — é regra do lote, não confirmação financeira de resgate.",
  expired:
    "Prévia com base nos saldos da listagem carregada: validade já passou. Não substitui o total disponível do summary.",
  within:
    "Prévia com base nos saldos da listagem carregada: ainda dentro do prazo de uso do participante.",
  ineligible:
    "Prévia com base na listagem: lotes não elegíveis (bloqueados ou isentos, ex.: entrada via PIX).",
  openLots:
    "Quantidade de saldos na página/listagem carregada — não é necessariamente o total da empresa.",
};
